import { Injectable      } from '@angular/core';
import { NotifierManager } from '../managers/notifier/notifier.manager';
import { Notifier        } from '../enums/notifier/notifier.enum';
import { NotifierMessage } from '../enums/notifier/message/notifier.enum';

@Injectable
({
  providedIn: 'root'
})

export class ServiceCalendar  
{
    constructor(private _notifier : NotifierManager) {}

    uGeneric()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.SERVICE_CALENDAR_U_GENERIC)
    }

    dGeneric()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.SERVICE_CALENDAR_D_GENERIC)
    }

    sGeneric()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.SERVICE_CALENDAR_S_GENERIC)
    }

    uNotAuth()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.SERVICE_CALENDAR_U_NOT_AUTH)
    }

    dNotAuth()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.SERVICE_CALENDAR_D_NOT_AUTH)
    }

    sNotAuth()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.SERVICE_CALENDAR_S_NOT_AUTH)
    }

    uInvalidOpenTime()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.SERVICE_CALENDAR_U_INVALID_OPEN_TIME)
    }

    uInvalidCloseTime()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.SERVICE_CALENDAR_U_INVALID_CLOSE_TIME)
    }

    uTimeSuperimposed()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.SERVICE_CALENDAR_U_TIME_SUPERIMPOSED)
    }
}